import { render, staticRenderFns } from "./receiveForm.vue?vue&type=template&id=2b4fe542&scoped=true&"
import script from "./receiveForm.vue?vue&type=script&lang=js&"
export * from "./receiveForm.vue?vue&type=script&lang=js&"
import style0 from "./receiveForm.vue?vue&type=style&index=0&id=2b4fe542&prod&scoped=true&lang=less&"
import style1 from "./receiveForm.vue?vue&type=style&index=1&id=2b4fe542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fe542",
  null
  
)

export default component.exports